import axios from 'axios';

const createWidget = widget => axios.post('widgets/create', widget);

const updateWidget = ({ id, ...params }) => axios.put(`widgets/${id}`, params);

const deleteWidget = ({ id }) => axios.delete(`widgets/${id}`);

export { createWidget, updateWidget, deleteWidget };
